import { invert as _invert, isArray as _isArray } from 'lodash';
import { baseApi } from '../../core/api/rtk/baseApi';

export const defaultUnits: Record<string, Record<string, any>> = {
  Water: {
    Gallons: 0,
    'Cubic Feet': 1,
    Liters: 2,
    '1000 Gallons': 3,
    'Centum Cubic Feet': 4,
  },
  Electric: { kWh: 0 },
  Gas: {
    Gallons: 0,
    Therms: 1,
    '1000 Gallons': 2,
    'Cubic Feet': 3,
    'Centum Cubic Feet': 4,
  },
  Sewer: {
    Gallons: 0,
    'Cubic Feet': 1,
    Liters: 2,
    '1000 Gallons': 3,
    'Centum Cubic Feet': 4,
  },
  WaterSewer: {
    Gallons: 0,
    'Cubic Feet': 1,
    Liters: 2,
    '1000 Gallons': 3,
    'Centum Cubic Feet': 4,
  },
};

export const utilitiesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUtilities: builder.query<any, { siteId?: number | null; types?: string; page?: number }>({
      query: ({ types, page }) => ({
        url: `utilities?types=${types ?? ''}&page=${page ?? 0}`,
        method: 'GET',
      }),
      providesTags: ['Utility'],
    }),
    getUtility: builder.query<any, { id: number; siteId?: number | null }>({
      query: ({ id }) => ({ url: `utilities/${id}`, method: 'GET' }),
      providesTags: ['Utility'],
    }),
    getUtilityUnits: builder.query<any, { siteId?: number | null }>({
      query: () => ({ url: 'utilities/units', method: 'GET' }),
      transformResponse: (response: any) => {
        const transformedUnits = { ...defaultUnits };
        const units = response?.results;
        if (units && _isArray(units)) {
          const existingUtilityTypes = Object.keys(defaultUnits);
          units.forEach((entry: any) => {
            if (existingUtilityTypes.indexOf(entry.utilityType) >= 0) {
              transformedUnits[entry.utilityType] = _invert({ ...entry.units });
            }
          });
        }
        return transformedUnits;
      },
      providesTags: ['UtilityUnit'],
    }),
    addUtility: builder.mutation<any, any>({
      query: (body) => ({ url: 'utilities', method: 'POST', body }),
      invalidatesTags: ['Utility'],
    }),
    updateUtility: builder.mutation<any, any>({
      query: ({ id, ...body }) => ({ url: `utilities/${id}`, method: 'PATCH', body }),
      invalidatesTags: ['Utility'],
    }),
    deleteUtility: builder.mutation<any, { id: number }>({
      query: ({ id }) => ({ url: `utilities/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Utility'],
    }),
    addUtilityLineItems: builder.mutation<any, { utilityId: number; items: any[] }>({
      query: ({ utilityId, items }) => ({
        url: `utilities/${utilityId}/line-items`,
        method: 'POST',
        body: { items },
      }),
      invalidatesTags: ['Utility'],
    }),
  }),
});

export const {
  useGetUtilitiesQuery,
  useGetUtilityQuery,
  useGetUtilityUnitsQuery,
  useAddUtilityMutation,
  useUpdateUtilityMutation,
  useDeleteUtilityMutation,
  useAddUtilityLineItemsMutation,
} = utilitiesApi;
